import { render, staticRenderFns } from "./PresidentialElectionsSecondRound.vue?vue&type=template&id=443f6eac&"
import script from "./PresidentialElectionsSecondRound.vue?vue&type=script&lang=js&"
export * from "./PresidentialElectionsSecondRound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('443f6eac')) {
      api.createRecord('443f6eac', component.options)
    } else {
      api.reload('443f6eac', component.options)
    }
    module.hot.accept("./PresidentialElectionsSecondRound.vue?vue&type=template&id=443f6eac&", function () {
      api.rerender('443f6eac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/presidential-elections-second-round/PresidentialElectionsSecondRound.vue"
export default component.exports